var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[_vm.$style.dots, _vm.unpadded ? _vm.$style.dotsUnpadded : '']},[_vm._v("...")])
}
var staticRenderFns = []

export { render, staticRenderFns }